import { Component, OnInit } from '@angular/core';
import { AmtlicherWertDetailEntry, StimeService } from '../../../../core/amtlichebewertung-stime-api';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RubrikComponent } from '../../../../shared/components/rubrik/rubrik.component';
import { AbstractGrundstueckEntryFromRoute } from '../../../grundstueck-rubriken/abstract-grundstueck-entry-from.route';
import { GbgrundstueckService } from '../../../../core/gb-api';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { BeschreibungTableWrapperComponent } from '../../../../shared/components/table/beschreibung-table-wrapper.component';
import { DatePipe } from '@angular/common';
import { BetragPipe } from '../../../../shared/pipes/simple/betrag.pipe';
import { DecimalHochkommaPipe } from '../../../../shared/pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-amtliche-bewertung-detail',
  templateUrl: './amtliche-bewertung-detail.component.html',
  styleUrl: './amtliche-bewertung-detail.component.scss',
  imports: [RubrikComponent, TranslatePipe, DatePipe, BeschreibungTableWrapperComponent, BetragPipe, DecimalHochkommaPipe]
})
export class AmtlicheBewertungDetailComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  amtlicherWertDetail: AmtlicherWertDetailEntry;
  protected tableFullWidth: boolean = true;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected translate: TranslateService,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected stimeService: StimeService
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected loadData() {
    this.stimeService.loadStimeDetail(this.gsId.id).subscribe((data) => {
      this.amtlicherWertDetail = data;
    });
  }

  joinSchaetzungDescription(first: string, second: string): string {
    return [first, second].filter((val) => val).join(' ');
  }
}
